import { Divider, Typography } from 'antd';

import { useAntDesignTheme } from '@/hooks/useAntDesignTheme';
import { useBillingSnapshot } from '@/hooks/useBillingSnapshot';
import BillingPlanActions from '@/shared/components/billing/BillingPlanActions';

export default function BillingAddress() {
    const { token } = useAntDesignTheme();
    const { snapshot } = useBillingSnapshot();
    const address = snapshot?.customer?.billingAddress;
    return (
        <>
            <Typography.Title level={5}>Billing Address</Typography.Title>
            <div style={{ color: token.colorTextTertiary }}>
                {address ? (
                    <>
                        <div>{address.line1 ?? '—'}</div>
                        {address.line2 ? <div>{address.line2}</div> : null}
                        <div>{[address.city, address.state].filter(Boolean).join(', ') || '—'}</div>
                        <div>{address.postalCode ?? '—'}</div>
                        <div>{address.country ?? '—'}</div>
                    </>
                ) : (
                    'No billing address recorded.'
                )}
            </div>
            <Divider style={{ margin: '1rem 0' }} />
            <BillingPlanActions />
        </>
    );
}
